import { Injectable } from "@angular/core";
import { AdRequestFormatTemplate, AlloxApiService } from "@app/core";
import { map } from "rxjs/operators";
import { AdRequestFormatTemplateSearchParam } from "@app/core/models/ad-request-format-template-search-param.model";

@Injectable({ providedIn: 'root' })
export class AdRequestFormatTemplateService {

    private path = '/ad_request_format_templates';

    constructor(
        private http: AlloxApiService,
    ) { }

    /**
     * 検索
     * @remarks
     * 広告リクエストフォーマットテンプレートを検索する。
     * @param ｛AdRequestFormatTemplateSearchParam｝ param - 広告リクエストフォーマットテンプレートの検索パラメータ
     * @returns 広告リクエストフォーマットテンプレート情報
     */
    public search(param?: AdRequestFormatTemplateSearchParam) {
        let url = this.path;
        if (param) {
            url += param.toURLQuery();
        }
        return this.http.get<[]>(url).pipe(
            map(objs => objs.map(obj => new AdRequestFormatTemplate(obj)))
        );
    }
}
